import { environment } from 'src/environments/environment';
import { Observable, Subject, throwError } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class AppConfigService {

  private appConfig: AppConfig;  

  constructor() {    
    this.appConfig = environment.appConfig;
  }

  getConfig() {
    return this.appConfig;
  }
  
}

export class AppConfig {
  identity_api_url: string;  
  oc_api_url: string;
  signalR_url:string;
  comm_api_url: string;
  reports_api_url: string;
  reports_migration_url:string;
  reminders_api_url: string;  
  appInsightsInstrumentationKey: string;
  recalls_api_url: string;
  dentally_integration_url: string;
  survey_service_api_url: string;
  dentally_client_id: string;
  dentally_scopes: string;
  amplitude_key:string;
  heap_key:string;
  curnex_api_url:string;
}
